// import 'babel-polyfill';
import React from 'react';
import './index.less';

const noticeTemp = global.useTemp || '';
const UseTemp = () => (
  <div className="useContainer" dangerouslySetInnerHTML={{ __html: noticeTemp }} />
);
export default UseTemp;
